import { Link } from "react-router-dom";
import { useConfig } from "@/context/ConfigContext";

export const Footer = () => {
  const { config } = useConfig();
  const seo = [
    { to: "/mutuelle-famille", label: "Mutuelle santé famille" },
    { to: "/mutuelle-senior", label: "Mutuelle santé senior" },
    { to: "/mutuelle-independants", label: "Mutuelle indépendant / TNS" },
    { to: "/assurance-expatrie", label: "Assurance santé expatrié" },
    { to: "/assurance-internationale", label: "Assurance santé internationale" },
    { to: "/assurance-premier-euro", label: "Assurance au premier euro" },
    { to: "/assurance-cfe", label: "Complémentaire CFE" },
  ];
  return (
    <footer className="brand-navy text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          {config.logo_url ? (
            <img src={config.logo_url} alt={config.brand_name} className="h-14 w-auto mb-4 bg-white rounded-xl p-2.5" />
          ) : (
            <h3 className="font-display font-bold text-white text-lg mb-3">{config.brand_name}</h3>
          )}
          <p className="text-sm text-slate-400 leading-relaxed">
            Comparateur de solutions santé pour particuliers en France et expatriés à l'étranger,
            avec l'accompagnement d'un courtier.
          </p>
          {config.orias_number && (
            <p className="text-xs text-slate-500 mt-4">ORIAS : {config.orias_number}</p>
          )}
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wide">Nos guides</h4>
          <ul className="space-y-2 text-sm">
            {seo.map((s) => (
              <li key={s.to}>
                <Link to={s.to} className="hover:text-white transition-colors">{s.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wide">Simulateurs</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/simulateur/mutuelle-france" className="hover:text-white">Comparer les mutuelles santé</Link></li>
            <li><Link to="/simulateur/assurance-expat" className="hover:text-white">Comparer les assurances expatrié</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wide">Informations</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/confidentialite" className="hover:text-white">Politique de confidentialité</Link></li>
            {config.contact_email && <li className="text-slate-400">{config.contact_email}</li>}
            {config.contact_phone && <li className="text-slate-400">{config.contact_phone}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {config.brand_name}. Les informations présentées ne constituent pas un conseil contractuel.
        Aucune offre n'est présentée comme un contrat réel sans validation d'un conseiller.
      </div>
    </footer>
  );
};
